import Checkbox from '@mui/material/Checkbox';
import React  from 'react';
const Empty = () => {
    const [checked, setChecked] = React.useState(false);

    function handleChange(){
        setChecked(!checked);
    }
    return (
       <div><Checkbox
       checked={checked}
       onClick={handleChange}
       inputProps={{ 'aria-label': 'controlled' }}
     /></div>
    )
}

export default Empty;